import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsBar from './components/StatsBar';
import CatalogTree from './components/CatalogTree';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <StatsBar />
        <CatalogTree />
      </main>
      <Footer />
    </div>
  );
}